import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import { VENUE_USER_LIST_QUERY, VENUE_USER_READ_QUERY } from "./queries";
import {
  VENUE_USER_CREATE_MUTATION,
  VENUE_USER_DELETE_MUTATION,
  VENUE_USER_UPDATE_MUTATION,
} from "./mutations";
import {
  VenueUserRead,
  VenueUserReadVariables,
  VenueUserList,
  VenueUserListVariables,
} from "./__generated__/queries";
import {
  VenueUserCreate,
  VenueUserCreateVariables,
  VenueUserUpdate,
  VenueUserUpdateVariables,
  VenueUserDelete,
  VenueUserDeleteVariables,
} from "./__generated__/mutations";

export const useVenueUserReadQuery = makeQueryHook<
  VenueUserRead,
  VenueUserReadVariables
>(VENUE_USER_READ_QUERY);

export const useVenueUserListQuery = makeQueryHook<
  VenueUserList,
  VenueUserListVariables
>(VENUE_USER_LIST_QUERY);

export const useVenueUserCreateMutation = makeMutationHook<
  VenueUserCreate,
  VenueUserCreateVariables
>(VENUE_USER_CREATE_MUTATION);

export const useVenueUserUpdateMutation = makeMutationHook<
  VenueUserUpdate,
  VenueUserUpdateVariables
>(VENUE_USER_UPDATE_MUTATION);

export const useVenueUserDeleteMutation = makeMutationHook<
  VenueUserDelete,
  VenueUserDeleteVariables
>(VENUE_USER_DELETE_MUTATION);
